// extracted by mini-css-extract-plugin
export default {"root":"MainLayout-root-a12d17baf1af8d6299355700ffd5aefd"};